import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Snackbar from '../components/snackbar';
import * as Action from '../actions/commonAction';

function mapStateToProps(state) {
  return {
    // ...state,
    open: state.Snackbar.open,
    message: state.Snackbar.message,
    type: state.Snackbar.type,
    time: state.Snackbar.time
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...Action,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
